import {combineReducers} from "redux";
import Settings from "./Settings";
import Auth from "./Auth";
import Common from "./Common";
import {connectRouter} from 'connected-react-router'

export default (history) => combineReducers({ // eslint-disable-line import/no-anonymous-default-export
  router: connectRouter(history),
  settings: Settings,
  auth: Auth,
  common: Common,
});
